export const isDevEnv = (): boolean => {
    return window?.location?.hostname !== 'www.airtel.in';
};
